export default "__VITE_ASSET__Bhb8hgRX__"